import tippy from 'tippy.js/dist/tippy.umd.js';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.tooltip').forEach(tooltip => {
    tippy(tooltip, {
      content: '',
      trigger: 'manual',
      theme: 'custom',
      arrow: true,
    });

    tooltip.addEventListener('click', () => {
      const button = tooltip.querySelector('.tooltip-container button');
      if (!button) return;

      const newContent = button.getAttribute('data-toggletip-content') || 'Tooltip vide';
      tooltip._tippy.setContent(newContent);
      tooltip._tippy.show();
    });
  });
});
